/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/images/pokedex/vue-structure.png",
        "alt": "Estructura de archivos de Vue"
      }}></img></p>
    <p><em parentName="p">{`Vue`}</em>{` al igual que `}<em parentName="p">{`React`}</em>{` solo mantiene el `}<inlineCode parentName="p">{`favicon`}</inlineCode>{` y el `}<inlineCode parentName="p">{`html`}</inlineCode>{` base en public.`}</p>
    <p>{`El resto del código, estilos, imagen y archivos se encuentran en el folder `}<em parentName="p">{`src`}</em>{`.`}</p>
    <p>{`Lo `}<strong parentName="p">{`maravilloso`}</strong>{` de Vue es que nos devuelve archivos como `}<inlineCode parentName="p">{`babel.config.js`}</inlineCode>{` o `}<inlineCode parentName="p">{`.eslintrc.js`}</inlineCode>{` para que modifiques la configuración de tu entorno de desarrollo muy fácilmente.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;